import {
  Step as FumadocsStep,
  Steps as FumadocsSteps,
} from "fumadocs-ui/components/steps";
import type { ReactNode } from "react";

type StepsProps = {
  children: ReactNode;
};

type StepProps = {
  title: string;
  children: ReactNode;
};

export function Steps({ children }: StepsProps) {
  return <FumadocsSteps>{children}</FumadocsSteps>;
}

export function Step({ children, title }: StepProps) {
  return (
    <FumadocsStep>
      <h3 className="not-prose mb-2 mt-0 text-lg font-semibold">{title}</h3>
      {children}
    </FumadocsStep>
  );
}
